import { Link } from 'react-router-dom';

const formatForFeed = function formatDataForSemanticUiCardFeed(data) {
  return data
    .filter(card => card.snippet.title !== 'Private video')
    .map(card => ({
      header: card.snippet.title,
      image: card.snippet.thumbnails.medium.url,
      description: card.snippet.description,
      key: card.id,
      as: Link,
      to: `/video/${card.snippet.resourceId.videoId}`,
    }));
};

export default formatForFeed;



// WEBPACK FOOTER //
// ./src/components/getPlaylistEpisodes/formatForFeed.js